import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const blockquoteAvatarCarouoselSelector = '.js-block-blockquote-carousel-avatars';
	const blockquoteCarouoselItemSelector = '.js-bca';
	const elements = document.querySelectorAll(blockquoteAvatarCarouoselSelector);

	if (!elements.length) {
		return;
	}

	const { BlockquoteCarouselAvatars } = await import('./blockquote-carousel-avatars');

	[...elements].forEach((element) => {
		const carousel = new BlockquoteCarouselAvatars({
			element,
			blockClass: 'block-blockquote-carousel-avatars',
			nextElementSelector: `${blockquoteCarouoselItemSelector}-chevron-next`,
			prevElementSelector: `${blockquoteCarouoselItemSelector}-chevron-prev`,
			blockquoteSelector: `${blockquoteCarouoselItemSelector}-blockquote`,
			itemSelector: `${blockquoteCarouoselItemSelector}-item`,
			progressCircleSelector: `${blockquoteCarouoselItemSelector}-progress-circle`,
			cardParagraphSelector: `${blockquoteCarouoselItemSelector}-blockquote-paragraph`,
			cardIntroSelector: `${blockquoteCarouoselItemSelector}-blockquote-intro`,
			cardButtonSelector: `${blockquoteCarouoselItemSelector}-blockquote-button`,
			cardButtonLabelSelector: `${blockquoteCarouoselItemSelector}-blockquote-button .js-button-label`,
			personInfoMobileSelector: `${blockquoteCarouoselItemSelector}-person-info-mobile`,
		});
		carousel.init();
	});
});
